<template>
  <div>
    <!-- =========================================================
         TODAY'S EXAM
    ========================================================== -->
    <v-card color="white">
      <v-layout row wrap>
        <v-card flat>
          <v-card-text class="title" style="margin-top:16px;">
            Today's Exam
          </v-card-text>
        </v-card>

        <v-divider class="my-2 hidden-xs-only" vertical></v-divider>

        <v-spacer />

        <v-flex class="customeDateSearch" xs12 sm6 md3 lg2>
          <v-menu :close-on-content-click="true">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="searchParam.date"
                label="Select Exam date"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>

            <v-date-picker
              v-model="searchParam.date"
              @input="getRoutineatDasboard(searchParam.date)"
            ></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- =========================================================
         TODAY'S EXAM TABLE
    ========================================================== -->
    <div class="responsive-table-scroll">
      <v-data-table
        :headers="Rheaders"
        :items="getAdminDashboardRoutin"
        class="elevation-1"
        hide-actions
      >
        <template v-slot:items="props">
          <!-- SL -->
          <td class="text-xs-left">
            {{ props.index + 1 }}
          </td>

          <!-- Exam Date -->
          <td class="text-xs-left">
            {{ props.item.exam_date ? props.item.exam_date : "" }}
          </td>

          <!-- Exam Code -->
          <td class="text-xs-left">
            {{ props.item.exam_code ? props.item.exam_code : "" }}
          </td>

          <!-- Exam Name -->
          <td class="text-xs-left">
            {{ props.item.exam_name ? props.item.exam_name : "" }}
          </td>

          <!-- Exam Year -->
          <td class="text-xs-left">
            {{ props.item.exam_year ? props.item.exam_year : "" }}
          </td>

          <!-- Start Time -->
          <td class="text-xs-left">
            {{ props.item.start_time ? props.item.start_time : "" }}
          </td>

          <!-- Duration -->
          <td class="text-xs-left">
            {{ props.item.exam_duration ? props.item.exam_duration : "" }}
          </td>

          <!-- ACTION -->
          <td class="text-xs-left">
            <v-layout row justify-center>
              <!-- =========================================
                   ATTENDANCE REPORT
              ========================================== -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="#7C3AED"
                    fab
                    outline
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="att_report(props.item)"
                    class="ghost-btn"
                  >
                    <v-icon color="#7C3AED">
                      report
                    </v-icon>
                  </v-btn>
                </template>

                <span>
                  Attendance Report
                </span>
              </v-tooltip>

              <!-- =========================================
                   UPDATE VIEW
              ========================================== -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="active_btn"
                    color="#E85D2F"
                    fab
                    outline
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="confirmUpdateView(props.item)"
                    :disabled="
                      [1, 2, 3, 4].includes(Number(props.item.degree_code))
                    "
                    class="ghost-btn"
                  >
                    <v-icon>
                      update
                    </v-icon>
                  </v-btn>
                </template>

                <span>
                  Update View
                </span>
              </v-tooltip>

              <!-- =========================================
                   VIEW PAPER
              ========================================== -->
              <v-dialog v-model="dialog" persistent max-width="600px">
                <template
                  v-slot:activator="{
                    on: dialogOn,
                    attrs: dialogAttrs,
                  }"
                >
                  <v-tooltip top>
                    <template
                      v-slot:activator="{
                        on: tooltipOn,
                        attrs: tooltipAttrs,
                      }"
                    >
                      <v-btn
                        color="#0891B2"
                        class="ghost-btn"
                        outline
                        @click="
                          getPaper(props.item.exam_code, props.item.papers)
                        "
                        dark
                        fab
                        small
                        v-bind="{
                          ...dialogAttrs,
                          ...tooltipAttrs,
                        }"
                        v-on="{
                          ...dialogOn,
                          ...tooltipOn,
                        }"
                      >
                        <v-icon>
                          sticky_note_2
                        </v-icon>
                      </v-btn>
                    </template>

                    <span>
                      View Paper
                    </span>
                  </v-tooltip>
                </template>

                <v-card>
                  <v-card-title>
                    <span class="headline">
                      Exam Papers of
                    </span>

                    <span class="headline">
                      <b
                        style="
                          margin-left:5px;
                        "
                      >
                        ({{ ExamCode }})
                      </b>
                    </span>

                    <v-spacer />

                    <v-btn
                      fab
                      small
                      color="red darken-3"
                      @click="dialog = false"
                    >
                      <v-icon color="light">
                        close
                      </v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-card-text style="margin-top:-40px;">
                    <v-container>
                      <div
                        class="
                          responsive-table-scroll
                        "
                      >
                        <table id="rcitemList">
                          <thead
                            style="
                              background-color:#2497A7;
                              color:#fff;
                            "
                          >
                            <th id="RCitem">
                              <span>
                                SL
                              </span>
                            </th>

                            <th id="RCitem">
                              Paper Code
                            </th>

                            <th id="RCitem">
                              Paper Name
                            </th>

                            <th id="RCitem">
                              Exam Date
                            </th>
                          </thead>

                          <tbody>
                            <tr
                              v-for="(paperitem, index) in getitemData"
                              :key="index"
                            >
                              <td id="RCitem">
                                {{ index + 1 }}
                              </td>

                              <td id="RCitem">
                                {{
                                  paperitem && paperitem.paper_code
                                    ? paperitem.paper_code
                                    : "Not found"
                                }}
                              </td>

                              <td id="RCitem">
                                {{
                                  paperitem && paperitem.paper_name
                                    ? paperitem.paper_name
                                    : "Not found"
                                }}
                              </td>

                              <td id="RCitem">
                                {{
                                  paperitem && paperitem.date
                                    ? paperitem.date
                                    : "Not found"
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-layout>
          </td>
        </template>
      </v-data-table>
    </div>

    <!-- =========================================================
         ATTENDANCE REPORT
    ========================================================== -->
    <v-layout row justify-center>
      <v-dialog
        v-model="att_dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>
              {{ searchParam.exam_code }}
              -
              {{ searchParam.exam_name }}
              /
              {{ searchParam.exam_year }}
            </v-toolbar-title>

            <v-spacer />

            <v-btn
              small
              color="white darken-3"
              style="color:indigo;"
              @click="att_report(selected_exam)"
            >
              <v-icon color="light">
                restore
              </v-icon>

              Reload
            </v-btn>

            <v-btn fab small color="red darken-3" @click="att_dialog = false">
              <v-icon color="light">
                close
              </v-icon>
            </v-btn>
          </v-toolbar>

          <!-- ATTENDANCE SUMMARY CARDS (GLASSMORPHISM) -->
          <v-container fluid class="card-section glass-bg">
            <v-layout row wrap>
              <!-- TOTAL EXAMINEES -->
              <v-flex xs12 sm6 md3 class="card-flex">
                <v-card class="custom-card">
                  <v-card-title
                    class="card-title-area glass-card"
                    style="
                      background:
                      linear-gradient(
                        135deg,
                        rgba(13,59,124,0.55),
                        rgba(26,109,181,0.55)
                      );
                    "
                  >
                    <div
                      class="
                        card-header-row
                      "
                    >
                      <div class="icon-circle">
                        <v-icon class="card-icon">
                          groups
                        </v-icon>
                      </div>

                      <span class="card-title-text">
                        Total Examinees
                      </span>
                    </div>

                    <v-divider class="card-divider" />

                    <div
                      class="
                        card-bottom-row
                      "
                    >
                      <div>
                        <p class="card-body-text">
                          {{ total_examinee }}
                        </p>

                        <p class="card-sub-text">
                          All registered candidates
                        </p>
                      </div>

                      <span class="pct-badge">
                        100%
                      </span>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>

              <!-- TOTAL PRESENT -->
              <v-flex xs12 sm6 md3 class="card-flex">
                <v-card class="custom-card">
                  <v-card-title
                    class="card-title-area glass-card"
                    style="
                      background:
                      linear-gradient(
                        135deg,
                        rgba(15,110,86,0.55),
                        rgba(29,184,142,0.55)
                      );
                    "
                  >
                    <div
                      class="
                        card-header-row
                      "
                    >
                      <div class="icon-circle">
                        <v-icon class="card-icon">
                          check_circle
                        </v-icon>
                      </div>

                      <span class="card-title-text">
                        Total Present
                      </span>
                    </div>

                    <v-divider class="card-divider" />

                    <div
                      class="
                        card-bottom-row
                      "
                    >
                      <div>
                        <p class="card-body-text">
                          {{ total_present }}
                        </p>

                        <p class="card-sub-text">
                          Attended the exam
                        </p>
                      </div>

                      <span class="pct-badge">
                        {{
                          total_examinee > 0
                            ? ((total_present / total_examinee) * 100).toFixed(
                                2,
                              )
                            : 0
                        }}%
                      </span>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>

              <!-- TOTAL WANTING -->
              <v-flex xs12 sm6 md3 class="card-flex">
                <v-card class="custom-card">
                  <v-card-title
                    class="card-title-area glass-card"
                    style="
                      background:
                      linear-gradient(
                        135deg,
                        rgba(133,79,11,0.55),
                        rgba(212,132,26,0.55)
                      );
                    "
                  >
                    <div
                      class="
                        card-header-row
                      "
                    >
                      <div class="icon-circle">
                        <v-icon class="card-icon">
                          person_search
                        </v-icon>
                      </div>

                      <span class="card-title-text">
                        Total Wanting
                      </span>
                    </div>

                    <v-divider class="card-divider" />

                    <div
                      class="
                        card-bottom-row
                      "
                    >
                      <div>
                        <p class="card-body-text">
                          {{ total_center_wanting }}
                        </p>

                        <p class="card-sub-text">
                          Wanting candidates
                        </p>
                      </div>

                      <span class="pct-badge">
                        {{
                          total_examinee > 0
                            ? (
                                (total_center_wanting / total_examinee) *
                                100
                              ).toFixed(2)
                            : 0
                        }}%
                      </span>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>

              <!-- TOTAL ABSENT -->
              <v-flex xs12 sm6 md3 class="card-flex">
                <v-card class="custom-card">
                  <v-card-title
                    class="card-title-area glass-card"
                    style="
                      background:
                      linear-gradient(
                        135deg,
                        rgba(123,18,18,0.55),
                        rgba(192,57,43,0.55)
                      );
                    "
                  >
                    <div
                      class="
                        card-header-row
                      "
                    >
                      <div class="icon-circle">
                        <v-icon class="card-icon">
                          person_off
                        </v-icon>
                      </div>

                      <span class="card-title-text">
                        Total Absent
                      </span>
                    </div>

                    <v-divider class="card-divider" />

                    <div
                      class="
                        card-bottom-row
                      "
                    >
                      <div>
                        <p class="card-body-text">
                          {{ total_center_absent }}
                        </p>

                        <p class="card-sub-text">
                          Did not appear
                        </p>
                      </div>

                      <span class="pct-badge">
                        {{
                          total_examinee > 0
                            ? (
                                (total_center_absent / total_examinee) *
                                100
                              ).toFixed(2)
                            : 0
                        }}%
                      </span>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>

          <!-- CENTER NOT SCANNED -->
          <v-card
            style="
              padding:20px;
              padding-top:0%;
            "
          >
            <v-layout
              row
              wrap
              style="
                background-color:ghostwhite;
              "
            >
              <v-card
                flat
                style="
                  background-color:ghostwhite;
                "
              >
                <v-card-text class="title">
                  Center Not Scanned Yet
                </v-card-text>
              </v-card>

              <v-divider
                class="
                  my-2
                  hidden-xs-only
                "
                vertical
              ></v-divider>

              <v-spacer />
            </v-layout>

            <div
              class="
                responsive-table-scroll
              "
            >
              <v-data-table
                :headers="Nsheader"
                :items="center_not_scanned_yet"
                class="elevation-1"
                hide-actions
              >
                <template v-slot:items="props">
                  <tr :style="getStyle(props.item)">
                    <td>
                      {{ props.index + 1 }}
                    </td>

                    <td class="text-xs-left">
                      {{ props.item.center_code ? props.item.center_code : "" }}

                      -

                      {{ props.item.center_name ? props.item.center_name : "" }}
                    </td>

                    <td class="text-xs-center">
                      {{
                        props.item.total_examinee
                          ? props.item.total_examinee
                          : ""
                      }}
                    </td>

                    <td class="text-xs-center">
                      {{
                        props.item.center_mobile ? props.item.center_mobile : ""
                      }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card>

          <br />
          <br />

          <v-divider />

          <br />
          <br />

          <!-- ATTENDANCE WANTING LIST -->
          <v-card
            style="
              padding:20px;
              padding-top:1%;
            "
          >
            <v-layout
              row
              wrap
              style="
                background-color:ghostwhite;
              "
            >
              <v-card
                flat
                style="
                  background-color:ghostwhite;
                "
              >
                <v-card-text class="title">
                  Attendance Wanting List
                </v-card-text>
              </v-card>

              <v-divider
                class="
                  my-2
                  hidden-xs-only
                "
                vertical
              ></v-divider>

              <v-spacer />
            </v-layout>

            <div
              class="
                responsive-table-scroll
              "
            >
              <v-data-table
                :headers="wheader"
                :items="att_wanting_list"
                class="elevation-1"
                hide-actions
              >
                <template v-slot:items="props">
                  <tr :style="getStyle(props.item)">
                    <td>
                      {{ props.index + 1 }}
                    </td>

                    <td class="text-xs-left">
                      {{ props.item.center_code ? props.item.center_code : "" }}

                      -

                      {{ props.item.center_name ? props.item.center_name : "" }}
                    </td>

                    <td class="text-xs-center">
                      {{
                        props.item.total_present ? props.item.total_present : ""
                      }}
                    </td>

                    <td class="text-xs-center">
                      {{
                        parseInt(props.item.total_absent || 0) -
                          parseInt(props.item.total_wanting || 0)
                      }}
                    </td>

                    <td class="text-xs-center">
                      {{
                        props.item.total_wanting ? props.item.total_wanting : ""
                      }}
                    </td>

                    <td class="text-xs-center">
                      {{
                        props.item.total_examinee
                          ? props.item.total_examinee
                          : ""
                      }}
                    </td>

                    <td class="text-xs-center">
                      {{
                        props.item.center_mobile ? props.item.center_mobile : ""
                      }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- =========================================================
         UPDATE VIEW CONFIRMATION
    ========================================================== -->
    <v-dialog v-model="vueConfDialog" max-width="530">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            <v-icon>
              warning
            </v-icon>

            Alert
          </v-toolbar-title>

          <v-spacer />

          <v-toolbar-items>
            <v-btn icon dark color="red" @click="vueConfDialog = false">
              <v-icon>
                close
              </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <div
          class="card"
          style="
            padding:20px;
            padding-top:5%;
            text-align:center;
          "
        >
          <span
            style="
              font-size:19px;
            "
          >
            Do You want to Update View Table Data?
          </span>
        </div>

        <div
          style="
            text-align:center;
            padding-bottom:10px;
          "
        >
          <v-btn color="primary" @click="updateViewTable()">
            Save
          </v-btn>

          <v-btn color="error" @click="vueConfDialog = false">
            Cancel
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- =========================================================
         TODAY'S SONALI SHEBA
    ========================================================== -->
    <v-card color="white" style="margin-top:36px;">
      <v-layout row wrap>
        <v-card flat>
          <v-card-text class="title" style="margin-top:16px;">
            Today's Sonali Sheba
          </v-card-text>
        </v-card>

        <v-divider
          class="
            my-2
            hidden-xs-only
          "
          vertical
        ></v-divider>

        <v-spacer />

        <v-flex class="customeDateSearch" xs12 sm6 md3 lg2>
          <v-menu :close-on-content-click="true">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="searchParam.shonaliDate"
                label="Select Exam date"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>

            <v-date-picker
              v-model="searchParam.shonaliDate"
              @input="ShonaliShebaData(searchParam.shonaliDate)"
            ></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- SONALI SHEBA TABLE -->
    <div
      class="
        responsive-table-scroll
      "
    >
      <v-data-table
        :headers="SHeader"
        :items="getShonaliShebaData"
        class="elevation-1"
        hide-actions
      >
        <template v-slot:items="props">
          <td>
            {{ props.index + 1 }}
          </td>

          <td class="text-xs-left">
            {{ props.item.exam_code ? props.item.exam_code : "" }}

            -

            {{ props.item.exam_name ? props.item.exam_name : "" }}
          </td>

          <td class="exam-name">
            {{ props.item.exam_year ? props.item.exam_year : "" }}
          </td>

          <td class="exam-name">
            {{ props.item.ff_end_date ? props.item.ff_end_date : "" }}
          </td>
        </template>
      </v-data-table>
    </div>

    <!-- =========================================================
         ONGOING ACTIVITIES
    ========================================================== -->
    <v-layout row wrap>
      <!-- IN COURSE -->
      <v-flex xs12 sm12 md12>
        <v-card
          style="
            margin-top:20px;
            box-shadow:
              rgba(0,0,0,0.18)
              0px 0px 8px;
          "
        >
          <v-card-text
            class="title"
            style="
              margin-top:16px;
              border-bottom:
                1px solid #DBDBDB;
            "
          >
            Ongoing In-Course Mark Submission
          </v-card-text>
        </v-card>

        <div
          class="table-wrapper"
          style="
            background:#FAFAFA;
            backdrop-filter:blur(12px);
            -webkit-backdrop-filter:blur(12px);
            border:
              1px solid
              rgba(255,255,255,0.25);
            box-shadow:
              rgba(0,0,0,0.18)
              0px 8px 8px;
          "
        >
          <v-data-table
            v-if="
              getExamActivityData.data &&
                getExamActivityData.data.incourse_mark_submission &&
                getExamActivityData.data.incourse_mark_submission.length > 0
            "
            :headers="AcHeader"
            :items="getExamActivityData.data.incourse_mark_submission"
            class="elevation-1"
            hide-actions
          >
            <template v-slot:items="props">
              <td>
                {{ props.index + 1 }}
              </td>

              <td class="text-xs-left">
                {{ props.item.exam_code ? props.item.exam_code : "" }}

                -

                {{ props.item.exam_name ? props.item.exam_name : "" }}

                -

                {{ props.item.exam_year ? props.item.exam_year : "" }}
              </td>

              <td class="exam-name">
                {{ props.item.start_date ? props.item.start_date : "" }}
              </td>

              <td class="exam-name">
                {{ props.item.end_date ? props.item.end_date : "" }}
              </td>
            </template>
          </v-data-table>

          <div v-else class="empty-table-message">
            <span>
              No In-Course Mark Submission is running.
            </span>
          </div>
        </div>
      </v-flex>

      <!-- FORM FILL UP -->
      <v-flex xs12 sm12 md12>
        <v-card
          style="
            margin-top:20px;
            box-shadow:
              rgba(0,0,0,0.18)
              0px 0px 8px;
          "
        >
          <v-card-text
            class="title"
            style="
              margin-top:16px;
              border-bottom:
                1px solid #DBDBDB;
            "
          >
            Ongoing Form Fill-Up
          </v-card-text>
        </v-card>

        <div
          class="table-wrapper"
          style="
            background:#FAFAFA;
            backdrop-filter:blur(12px);
            -webkit-backdrop-filter:blur(12px);
            border:
              1px solid
              rgba(255,255,255,0.25);
            box-shadow:
              rgba(0,0,0,0.18)
              0px 8px 8px;
          "
        >
          <v-data-table
            v-if="
              getExamActivityData.data &&
                getExamActivityData.data.form_fill_up &&
                getExamActivityData.data.form_fill_up.length > 0
            "
            :headers="AcHeader"
            :items="getExamActivityData.data.form_fill_up"
            class="elevation-1"
            hide-actions
          >
            <template v-slot:items="props">
              <td>
                {{ props.index + 1 }}
              </td>

              <td class="text-xs-left">
                {{ props.item.exam_code ? props.item.exam_code : "" }}

                -

                {{ props.item.exam_name ? props.item.exam_name : "" }}

                -

                {{ props.item.exam_year ? props.item.exam_year : "" }}
              </td>

              <td class="exam-name">
                {{ props.item.start_date ? props.item.start_date : "" }}
              </td>

              <td class="exam-name">
                {{ props.item.end_date ? props.item.end_date : "" }}
              </td>
            </template>
          </v-data-table>

          <div v-else class="empty-table-message">
            <span>
              No Form Fill-Up is running.
            </span>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <!-- =========================================================
         PRACTICAL & VIVA
    ========================================================== -->
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card
          style="
            margin-top:20px;
            box-shadow:
              rgba(0,0,0,0.18)
              0px 0px 8px;
          "
        >
          <v-card-text
            class="title"
            style="
              margin-top:16px;
              border-bottom:
                1px solid #DBDBDB;
            "
          >
            Ongoing Practical & Viva Examination
          </v-card-text>
        </v-card>

        <div
          class="table-wrapper"
          style="
            background:#FAFAFA;
            backdrop-filter:blur(12px);
            -webkit-backdrop-filter:blur(12px);
            border:
              1px solid
              rgba(255,255,255,0.25);
            box-shadow:
              rgba(0,0,0,0.18)
              0px 8px 8px;
          "
        >
          <v-data-table
            v-if="
              getExamActivityData.data &&
                getExamActivityData.data
                  .practical_viva_thesis_mark_submission_completed &&
                getExamActivityData.data
                  .practical_viva_thesis_mark_submission_completed.length > 0
            "
            :headers="AcHeader"
            :items="
              getExamActivityData.data
                .practical_viva_thesis_mark_submission_completed
            "
            class="elevation-1"
            hide-actions
          >
            <template v-slot:items="props">
              <td>
                {{ props.index + 1 }}
              </td>

              <td class="text-xs-left">
                {{ props.item.exam_code ? props.item.exam_code : "" }}

                -

                {{ props.item.exam_name ? props.item.exam_name : "" }}

                -

                {{ props.item.exam_year ? props.item.exam_year : "" }}
              </td>

              <td class="exam-name">
                {{ props.item.start_date ? props.item.start_date : "" }}
              </td>

              <td class="exam-name">
                {{ props.item.end_date ? props.item.end_date : "" }}
              </td>
            </template>
          </v-data-table>

          <div v-else class="empty-table-message">
            <span>
              No Practical & Viva Examination is running.
            </span>
          </div>
        </div>
      </v-flex>

      <!-- =======================================================
           RECENT EXAMINATION SUMMARY
      ======================================================== -->
      <v-flex xs12 sm12 md12>
        <v-card
          style="
            margin-top:20px;
            box-shadow:
              rgba(0,0,0,0.18)
              0px 0px 8px;
            display:flex;
            justify-content:space-between;
            align-items:center;
          "
        >
          <v-card-text
            class="title"
            style="
              margin-top:16px;
              border-bottom:
                1px solid #DBDBDB;
            "
          >
            Recent Examination Summary
          </v-card-text>

          <v-btn
            color="primary"
            class="my-2 mr-3"
            @click="downloadExamSummary()"
          >
            <v-icon left>
              download
            </v-icon>

            Download Excel
          </v-btn>
        </v-card>

        <!-- RECENT EXAM TABLE -->
        <div
          class="table-wrapper"
          style="
            background:#FAFAFA;
            backdrop-filter:blur(12px);
            -webkit-backdrop-filter:blur(12px);
            border:
              1px solid
              rgba(255,255,255,0.25);
            box-shadow:
              rgba(0,0,0,0.18)
              0px 8px 8px;
          "
        >
          <v-data-table
            v-if="
              getExamActivityData.result_status &&
                getExamActivityData.result_status.length > 0
            "
            :headers="RHeader"
            :items="getExamActivityData.result_status"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="elevation-1"
            hide-actions
          >
            <template v-slot:items="props">
              <!-- SL -->
              <td>
                {{ props.index + 1 }}
              </td>

              <!-- EXAM -->
              <td class="text-xs-left">
                {{ props.item.exam_code ? props.item.exam_code : "" }}

                -

                {{ props.item.exam_name ? props.item.exam_name : "" }}

                -

                {{ props.item.exam_year ? props.item.exam_year : "" }}
              </td>

              <!-- START DATE -->
              <td class="exam-name">
                {{ props.item.start_date ? props.item.start_date : "" }}
              </td>

              <!-- END DATE -->
              <td class="exam-name">
                {{ props.item.end_date ? props.item.end_date : "" }}
              </td>

              <!-- PUBLISHED DATE -->
              <td class="exam-name">
                {{
                  props.item.published_date
                    ? props.item.published_date
                    : "Not Published"
                }}

                <!-- EDIT -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="props.item.published_date"
                      fab
                      small
                      outline
                      color="primary"
                      v-on="on"
                      @click="editPublishedDate(props.item)"
                    >
                      <v-icon>
                        edit
                      </v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Edit Published Date
                  </span>
                </v-tooltip>

                <!-- ADD -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="!props.item.published_date"
                      fab
                      small
                      outline
                      color="green"
                      v-on="on"
                      @click="addPublishedDate(props.item)"
                    >
                      <v-icon>
                        add
                      </v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Add Published Date
                  </span>
                </v-tooltip>
              </td>

              <!-- DAYS ELAPSED -->
              <td class="exam-name">
                <v-chip
                  small
                  :color="Number(props.item.days_gone) > 90 ? 'red' : 'green'"
                  dark
                >
                  {{
                    Number(props.item.days_gone) < 0
                      ? 0
                      : Number(props.item.days_gone)
                  }}
                </v-chip>
              </td>
            </template>
          </v-data-table>

          <div
            v-else
            class="
              empty-table-message
            "
          >
            <span>
              No Theory Examination is running.
            </span>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <!-- =========================================================
         ADD / EDIT PUBLISHED DATE DIALOG
    ========================================================== -->
    <v-dialog
      v-model="publishedDateDialog"
      max-width="520px"
      persistent
      scrollable
    >
      <v-card>
        <!-- HEADER -->
        <v-toolbar dark color="primary" flat>
          <v-toolbar-title>
            {{
              publishedDateMode === "add"
                ? "Add Published Date"
                : "Edit Published Date"
            }}
          </v-toolbar-title>

          <v-spacer />

          <v-btn icon dark @click="closePublishedDateDialog()">
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </v-toolbar>

        <!-- FORM -->
        <v-card-text>
          <v-form ref="publishedDateForm" v-model="publishedDateValid">
            <!-- EXAM -->
            <v-text-field
              label="Exam"
              :value="
                publishedDateForm.exam_code +
                  ' - ' +
                  publishedDateForm.exam_name +
                  ' - ' +
                  publishedDateForm.exam_year
              "
              prepend-icon="list"
              readonly
            ></v-text-field>

            <!-- START DATE -->
            <v-text-field
              label="Exam Start Date"
              v-model="publishedDateForm.start_date"
              prepend-icon="date_range"
              readonly
              disabled
            ></v-text-field>

            <!-- END DATE -->
            <v-text-field
              label="Exam End Date"
              v-model="publishedDateForm.end_date"
              prepend-icon="date_range"
              readonly
              disabled
            ></v-text-field>

            <!-- PUBLISHED DATE -->
            <v-menu
              v-model="publishedDatePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="publishedDateForm.published_date"
                  label="Published Date"
                  prepend-icon="event"
                  readonly
                  :rules="publishedDateRules.required"
                  v-on="on"
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="publishedDateForm.published_date"
                @input="publishedDatePicker = false"
              ></v-date-picker>
            </v-menu>
          </v-form>
        </v-card-text>

        <!-- ACTION -->
        <v-card-actions class="justify-center pb-4">
          <v-btn
            color="primary"
            :loading="publishedDateSaving"
            @click="savePublishedDate()"
          >
            <v-icon left>
              save
            </v-icon>

            Save
          </v-btn>

          <v-btn color="error" @click="closePublishedDateDialog()">
            <v-icon left>
              close
            </v-icon>

            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import common_login_getters from "@/mixin/common_login_getters";
import commonGet from "../../mixin/common_getters_mixin";
import commonExamYear from "../../mixin/exam_year_watch_mixin";
// import common_login_getters from "../../mixin/common_login_getters";

import formDialog from "@/components/examTimeline/timelineSetupForm.vue";

export default {
  components: {
    formDialog,
  },

  mixins: [common_login_getters, commonExamYear, commonGet],

  data: () => ({
    /* =========================================================
       SORT
    ========================================================== */

    sortBy: [],
    sortDesc: [],

    /* =========================================================
       GENERAL
    ========================================================== */

    dataList: {},

    user: "",

    active_btn: false,

    todaysDate: "",

    dialog: false,

    att_dialog: false,

    vueConfDialog: false,

    loading: false,

    /* =========================================================
       PUBLISHED DATE DIALOG
    ========================================================== */

    publishedDateDialog: false,

    publishedDatePicker: false,

    publishedDateValid: false,

    publishedDateMode: "add",

    publishedDateSaving: false,

    publishedDateForm: {
      exam_code: "",

      exam_name: "",

      exam_year: "",

      start_date: "",

      end_date: "",

      published_date: "",
    },

    publishedDateRules: {
      required: [(v) => !!v || "Published Date field can not be empty."],
    },

    /* =========================================================
       PAPER
    ========================================================== */

    peparData: [],

    ExamCode: "",

    /* =========================================================
       SEARCH
    ========================================================== */

    searchParam: {
      date: "",

      shonaliDate: "",

      exam_code: "",

      exam_name: "",

      exam_year: "",

      exam_initiate_id: "",
    },

    /* =========================================================
       ATTENDANCE
    ========================================================== */

    att_wanting_list: [],

    center_not_scanned_yet: [],

    sl_count: 0,

    exam_code: "",

    exam_name: "",

    exam_year: "",

    selected_exam: {},

    total_present: 0,

    total_absent: 0,

    total_wanting: 0,

    total_examinee: 0,

    total_center_wanting: 0,

    total_center_absent: 0,

    /* =========================================================
       SONALI SHEBA HEADER
    ========================================================== */

    SHeader: [
      {
        text: "Sl.",
        value: "",
        align: "left",
        sortable: false,
      },

      {
        text: "Exam Code & Name",
        value: "paper_code",
        align: "left",
        sortable: false,
      },

      {
        text: "Exam Year",
        value: "date",
        align: "center",
        sortable: false,
      },

      {
        text: "Form Fill-up End Date",
        value: "date",
        align: "center",
        sortable: false,
      },
    ],

    /* =========================================================
       ACTIVITY HEADER
    ========================================================== */

    AcHeader: [
      {
        text: "Sl.",
        value: "",
        align: "left",
        sortable: false,
      },

      {
        text: "Exam Code - Name - Year",
        value: "exam_code",
        align: "left",
        sortable: true,
      },

      {
        text: "Start Date",
        value: "start_day",
        align: "center",
        sortable: true,
      },

      {
        text: "End Date",
        value: "end_day",
        align: "center",
        sortable: true,
      },
    ],

    /* =========================================================
       RECENT EXAMINATION HEADER
    ========================================================== */

    RHeader: [
      {
        text: "Sl.",
        value: "",
        align: "left",
        sortable: false,
      },

      {
        text: "Exam Code - Name - Year",
        value: "exam_code",
        align: "left",
        sortable: true,
      },

      {
        text: "Start Date",
        value: "start_date",
        align: "center",
        sortable: true,
      },

      {
        text: "End Date",
        value: "end_date",
        align: "center",
        sortable: true,
      },

      {
        text: "Published Date",
        value: "published_date",
        align: "center",
        sortable: true,
      },

      {
        text: "Days Elapsed",
        value: "days_gone",
        align: "center",
        sortable: false,
      },
    ],

    /* =========================================================
       PAPER HEADER
    ========================================================== */

    Pheaders: [
      {
        text: "Paper Code",
        value: "paper_code",
        align: "left",
        sortable: false,
      },

      {
        text: "Paper Name",
        value: "paper_name",
        align: "center",
        sortable: false,
      },

      {
        text: "Exam Date",
        value: "date",
        align: "center",
        sortable: false,
      },
    ],

    /* =========================================================
       TODAY EXAM HEADER
    ========================================================== */

    Rheaders: [
      {
        text: "Sl.",
        value: "",
        align: "left",
        sortable: false,
      },

      {
        text: "Start Date",
        value: "exam_date",
        align: "left",
        sortable: false,
      },

      {
        text: "Exam Code",
        value: "exam_code",
        align: "left",
        sortable: false,
      },

      {
        text: "Exam Name",
        value: "exam_name",
        align: "left",
        sortable: false,
      },

      {
        text: "Exam Year",
        value: "exam_year",
        align: "left",
        sortable: false,
      },

      {
        text: "Exam Time",
        value: "start_time",
        align: "left",
        sortable: false,
      },

      {
        text: "Exam Duration",
        value: "exam_duration",
        align: "left",
        sortable: false,
      },

      {
        text: "Action",
        value: "",
        align: "left",
        sortable: false,
      },
    ],

    /* =========================================================
       WANTING HEADER
    ========================================================== */

    wheader: [
      {
        text: "Sl.",
        value: "",
        align: "left",
        sortable: false,
      },

      {
        text: "Center Code & Name",
        value: "",
        align: "left",
        sortable: false,
      },

      {
        text: "Total present",
        value: "",
        align: "center",
        sortable: false,
      },

      {
        text: "Total Absent",
        value: "",
        align: "center",
        sortable: false,
      },

      {
        text: "Total Attendance Wanted",
        value: "",
        align: "center",
        sortable: false,
      },

      {
        text: "Total Examinees",
        value: "",
        align: "center",
        sortable: false,
      },

      {
        text: "Phone",
        value: "",
        align: "center",
        sortable: false,
      },
    ],

    /* =========================================================
       NOT SCANNED HEADER
    ========================================================== */

    Nsheader: [
      {
        text: "Sl",
        value: "",
        align: "left",
        sortable: false,
      },

      {
        text: "Center Code & Name",
        value: "",
        align: "left",
        sortable: false,
      },

      {
        text: "Total Examinees",
        value: "",
        align: "center",
        sortable: false,
      },

      {
        text: "Phone",
        value: "",
        align: "center",
        sortable: false,
      },
    ],
  }),

  /* =========================================================
     CREATED
  ========================================================== */

  created() {
    this.searchParam.exam_initiate_id = this.getExamInitiateId;
    this.currentDate();

    this.getRoutineatDasboard();

    this.getExamActivityDashboard();

    this.ShonaliShebaData();

    this.getUserData();
  },

  /* =========================================================
     COMPUTED
  ========================================================== */

  computed: {
    getAdminDashboardRoutin() {
      return this.$store.getters.getAdminDashboardRoutin;
    },

    getitemData() {
      return this.peparData;
    },

    getCenManualAbsentEntryData() {
      return this.$store.getters.getCenManualAbsentEntryData;
    },

    getExamActivityData() {
      return this.$store.getters.getExamActivityData;
    },

    getShonaliShebaData() {
      return this.$store.getters.getShonaliShebaData;
    },
  },

  /* =========================================================
     METHODS
  ========================================================== */

  methods: {
    /* =========================================================
       USER DATA
    ========================================================== */

    getUserData() {
      let user = JSON.parse(localStorage.getItem("user"));

      if (!user) {
        return;
      }

      this.user = user.username;

      console.log("User Data Tanvir:", this.user);

      this.active_btn =
        this.user == "admin" ||
        this.user == "tanvir308ts6" ||
        this.user == "mehedi@ems.com" ||
        this.user == "momin@eatlbd.com" ||
        this.user == "mkraju.eatl@gmail.com";
    },

    /* =========================================================
       EXAM ACTIVITY
    ========================================================== */

    getExamActivityDashboard() {
      this.$store
        .dispatch("getExamActivityDashboard")
        .then((res) => {
          console.log("Exam Activity Dashboard Data:", res);
        })
        .catch((error) => {
          console.error("Exam Activity Dashboard Failed:", error);
        });
    },

    /* =========================================================
       SONALI SHEBA
    ========================================================== */

    ShonaliShebaData(data) {
      console.log("Selected Shonali Sheba Date:", data);

      if (data) {
        this.$store
          .dispatch("getShonaliShebaData", {
            ff_end_date: data,
          })
          .then((res) => {
            console.log("Selected Shonali Sheba:", res);
          });
      } else {
        this.$store
          .dispatch("getShonaliShebaData", {
            ff_end_date: this.todaysDate,
          })
          .then(() => {
            console.log("Today:", this.todaysDate);
          });
      }
    },

    /* =========================================================
       CURRENT DATE
    ========================================================== */

    currentDate() {
      const current = new Date().toJSON().slice(0, 10);

      this.todaysDate = current;

      console.log("Tanvir_Date:", this.todaysDate);

      return this.todaysDate;
    },

    /* =========================================================
       ROUTINE
    ========================================================== */

    getRoutineatDasboard(date) {
      if (date) {
        this.$store
          .dispatch("getRoutineAtAdminDashboard", {
            exam_date: date,
          })
          .then(() => {
            console.log("Selected Date:", date);
          });
      } else {
        this.$store
          .dispatch("getRoutineAtAdminDashboard", {
            exam_date: this.todaysDate,
          })
          .then(() => {
            console.log("Today:", this.todaysDate);
          });
      }
    },

    /* =========================================================
       DOWNLOAD EXAM SUMMARY
    ========================================================== */

    downloadExamSummary() {
      this.$store
        .dispatch("downloadDashboardExamSummary", this.todaysDate)
        .then((res) => {
          console.log("Exam Summary Downloaded:", res);
        })
        .catch((error) => {
          console.error("Exam Summary Download Failed:", error);
        });
    },

    /* =========================================================
       ADD PUBLISHED DATE
    ========================================================== */

    addPublishedDate(item) {
      console.log("Add Published Date:", item);

      this.publishedDateMode = "add";

      this.publishedDateForm = {
        exam_code: item.exam_code || "",

        exam_name: item.exam_name || "",

        exam_year: item.exam_year || "",

        start_date: item.start_date || "",

        end_date: item.end_date || "",

        published_date: "",

        exam_initiate_id: item.exam_initiate_id || "",
      };

      this.publishedDateDialog = true;

      this.$nextTick(() => {
        if (this.$refs.publishedDateForm) {
          this.$refs.publishedDateForm.resetValidation();
        }
      });
    },

    /* =========================================================
       EDIT PUBLISHED DATE
    ========================================================== */

    editPublishedDate(item) {
      console.log("Edit Published Date:", item);

      this.publishedDateMode = "edit";

      this.publishedDateForm = {
        exam_code: item.exam_code || "",

        exam_name: item.exam_name || "",

        exam_year: item.exam_year || "",

        start_date: item.start_date || "",

        end_date: item.end_date || "",

        published_date: item.published_date || "",

        exam_initiate_id: item.exam_initiate_id || "",
      };

      this.publishedDateDialog = true;

      this.$nextTick(() => {
        if (this.$refs.publishedDateForm) {
          this.$refs.publishedDateForm.resetValidation();
        }
      });
    },

    /* =========================================================
       CLOSE PUBLISHED DATE DIALOG
    ========================================================== */

    closePublishedDateDialog() {
      this.publishedDateDialog = false;

      this.publishedDatePicker = false;

      this.publishedDateSaving = false;

      this.publishedDateForm = {
        exam_code: "",

        exam_name: "",

        exam_year: "",

        start_date: "",

        end_date: "",

        published_date: "",
      };
    },

    /* =========================================================
       SAVE PUBLISHED DATE
    ========================================================== */

    savePublishedDate() {
      if (
        this.$refs.publishedDateForm &&
        !this.$refs.publishedDateForm.validate()
      ) {
        return;
      }

      if (!this.publishedDateForm.published_date) {
        return;
      }

      this.publishedDateSaving = true;
      console.log("Saving tada:", this.publishedDateForm);
      const param = {
        published_date: this.publishedDateForm.published_date,
        activity_id: "12",
        notice:"308",
        start_date:this.publishedDateForm.published_date,
        end_date:this.publishedDateForm.published_date,
        exam_initiate_id: this.publishedDateForm.exam_initiate_id,
      };

      console.log("Saving Published Date:", param);

      /*
       * IMPORTANT:
       *
       * এখানে তোমার Vuex action
       * updatePublishedDate
       * ব্যবহার করা হয়েছে।
       *
       * যদি তোমার store-এ অন্য নাম থাকে,
       * শুধু action name change করবে।
       */

      this.$store
        .dispatch("setResultPublishdate", param)
        .then((res) => {
          console.log("Published Date Saved:", res);

          this.publishedDateDialog = false;

          this.publishedDatePicker = false;

          /*
           * Table refresh
           */

          this.getExamActivityDashboard();
        })
        .catch((error) => {
          console.error("Published Date Save Failed:", error);
        })
        .finally(() => {
          this.publishedDateSaving = false;
        });
    },

    /* =========================================================
       GET PAPER
    ========================================================== */

    getPaper(ExamCode, peparData) {
      this.ExamCode = ExamCode;

      this.peparData = peparData;

      console.log("Tanvir Paper:", this.peparData);
    },

    /* =========================================================
       TABLE STYLE
    ========================================================== */

    getStyle(item) {
      const totalExaminee = Number(item.total_examinee);

      const totalWanting = Number(item.total_wanting);

      const totalPresent = Number(item.total_present);

      if (totalExaminee === totalWanting) {
        return `
          background-color:brown;
          color:#fff;
        `;
      }

      if (totalPresent > 0 && totalWanting > 0) {
        return `
          background-color:#FFF59D;
        `;
      }

      return `
        background-color:white;
      `;
    },

    /* =========================================================
       ATTENDANCE REPORT
    ========================================================== */

    att_report(item) {
      this.att_dialog = true;

      this.loading = true;

      this.selected_exam = item;

      this.searchParam.exam_code = item.exam_code;

      this.searchParam.exam_name = item.exam_name;

      this.searchParam.exam_year = item.exam_year;

      this.searchParam.exam_initiate_id = item.exam_initiate_id;

      let param = {
        exam_date: this.searchParam.date || this.todaysDate,

        exam_initiate_id: this.searchParam.exam_initiate_id,

        exam_code: this.searchParam.exam_code,

        exam_year: this.searchParam.exam_year,

        exam_type: 1,
      };

      this.center_not_scanned_yet = [];

      this.att_wanting_list = [];

      this.$store
        .dispatch("searchCenManualAbsentEntryData", param)
        .then((res) => {
          this.sl_count = 1;

          this.total_examinee = res.total_examinee_count;

          this.total_present = res.total_present;

          this.total_absent = res.total_absent;

          this.calculateTotalCenterWanting(res.data);

          let center_not_scanned_yet = [];

          let att_wanting_list = [];

          if (res.data && res.data.length) {
            res.data.forEach((item) => {
              const total_examinee = Number(item.total_examinee);

              const total_wanting = Number(item.total_wanting);

              const total_present = Number(item.total_present);

              if (total_examinee === total_wanting) {
                center_not_scanned_yet.push(item);

                return;
              }

              if (total_present > 0 && total_wanting > 0) {
                att_wanting_list.push(item);
              }
            });
          }

          this.center_not_scanned_yet = center_not_scanned_yet;

          this.att_wanting_list = att_wanting_list;

          this.loading = false;
        })
        .catch((err) => {
          console.error(err);

          this.loading = false;
        });
    },

    /* =========================================================
       TOTAL CENTER WANTING
    ========================================================== */

    calculateTotalCenterWanting(data) {
      let total_absent = 0;

      let total_wanting = 0;

      if (data && data.length) {
        data.forEach((item) => {
          total_absent += parseInt(item.total_absent || 0);

          total_wanting += parseInt(item.total_wanting || 0);
        });
      }

      this.total_center_wanting = total_wanting;

      this.total_center_absent = total_absent - total_wanting;

      console.log("Total Center Wanting:", this.total_center_wanting);

      console.log("Total Center Absent:", this.total_center_absent);
    },

    /* =========================================================
       CONFIRM UPDATE VIEW
    ========================================================== */

    confirmUpdateView(item) {
      this.vueConfDialog = true;

      this.dataList = item;

      console.log("Data for update view:", this.dataList);
    },

    /* =========================================================
       UPDATE VIEW TABLE
    ========================================================== */

    updateViewTable() {
      this.updateView();
    },

    /* =========================================================
       UPDATE VIEW
    ========================================================== */

    updateView() {
      let param = {
        exam_code: this.dataList.exam_code,

        exam_year: this.dataList.exam_year,
      };

      this.$store
        .dispatch("updateViewData", param)
        .then((res) => {
          console.log("View updated successfully:", res);

          this.vueConfDialog = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style scoped>
/* =========================================================
   EXAM NAME
========================================================== */

.exam-name {
  white-space: nowrap;
}

/* =========================================================
   RESPONSIVE TABLE
========================================================== */

.responsive-table-scroll {
  width: 100%;

  overflow-x: auto;

  -webkit-overflow-scrolling: touch;
}

.table-wrapper {
  height: 300px;

  overflow-x: auto;

  overflow-y: auto;

  border: 1px solid #e0e0e0;

  background: #fff;
}

.table-wrapper thead th {
  position: sticky;

  top: 0;

  z-index: 2;
}

.table-wrapper tbody {
  height: calc(300px - 56px);
}

.white-table {
  background: #fff !important;
}

.white-table table {
  background: #fff !important;
}

.white-table thead th {
  background: #fff !important;

  position: sticky;

  top: 0;

  z-index: 10;
}

.white-table tbody tr {
  background: #fff !important;
}

/* =========================================================
   SCROLLBAR
========================================================== */

.table-wrapper::-webkit-scrollbar,
.responsive-table-scroll::-webkit-scrollbar {
  width: 10px;

  height: 10px;
}

.table-wrapper::-webkit-scrollbar-track,
.responsive-table-scroll::-webkit-scrollbar-track {
  background: #f0f0f0;
}

.table-wrapper::-webkit-scrollbar-thumb,
.responsive-table-scroll::-webkit-scrollbar-thumb {
  background: #bdbdbd;

  border-radius: 6px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover,
.responsive-table-scroll::-webkit-scrollbar-thumb:hover {
  background: #9e9e9e;
}

.table-wrapper::-webkit-scrollbar-corner {
  background: #f0f0f0;
}

/* Firefox */

.table-wrapper,
.responsive-table-scroll {
  scrollbar-width: thin;

  scrollbar-color: #bdbdbd #f0f0f0;
}

/* =========================================================
   PAPER TABLE
========================================================== */

#rcitemList {
  text-align: center;

  min-width: 480px;

  width: 100%;
}

#RCitem {
  padding: 10px;

  font-size: 18px;
}

/* =========================================================
   GHOST BUTTON
========================================================== */

.ghost-btn {
  background-color: transparent !important;

  transition: background-color 0.2s ease !important;
}

.ghost-btn:hover {
  background-color: #ffffff !important;
}

.ghost-btn:hover::before {
  background-color: transparent !important;

  opacity: 0 !important;
}

/* =========================================================
   EMPTY TABLE
========================================================== */

.empty-table-message {
  text-align: center;

  padding: 20px;

  margin-top: 14%;

  color: #546e7a;

  font-size: 14px;
}

/* =========================================================
   ATTENDANCE CARDS - GLASSMORPHISM
========================================================== */

/* Backdrop behind the glass cards - needs to be dark/rich
   enough that the translucent cards show real contrast.
   A near-white backdrop makes glass cards wash out completely. */
.glass-bg {
  background: linear-gradient(135deg, #1e2761 0%, #3b2f6b 45%, #1b4b6b 100%);

  border-radius: 0px;

  padding: 24px !important;

  position: relative;

  overflow: hidden;
}

/* Soft glow blobs to add visual variation for the blur to pick up */
.glass-bg::before,
.glass-bg::after {
  content: "";

  position: absolute;

  border-radius: 50%;

  filter: blur(60px);

  pointer-events: none;

  z-index: 0;
}

.glass-bg::before {
  width: 260px;

  height: 260px;

  background: rgba(124, 58, 237, 0.45);

  top: -80px;

  left: 10%;
}

.glass-bg::after {
  width: 300px;

  height: 300px;

  background: rgba(8, 145, 178, 0.4);

  bottom: -100px;

  right: 8%;
}

.glass-bg > .layout {
  position: relative;

  z-index: 1;
}

.card-flex {
  padding: 8px;
}

/* Outer v-card wrapper: transparent, no default shadow,
   let the glass-card inside handle the visuals */
.custom-card {
  border-radius: 18px !important;

  overflow: hidden;

  background: transparent !important;

  box-shadow: none !important;

  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.custom-card:hover {
  transform: translateY(-4px);
}

/* The actual frosted glass panel */
.glass-card {
  border-radius: 18px !important;

  backdrop-filter: blur(18px) saturate(180%);

  -webkit-backdrop-filter: blur(18px) saturate(180%);

  border: 1px solid rgba(255, 255, 255, 0.4);

  box-shadow:
    rgba(0, 0, 0, 0.3) 0px 8px 32px,
    inset 0 1px 0 rgba(255, 255, 255, 0.3);

  padding: 20px !important;
}

.custom-card:hover .glass-card {
  box-shadow:
    rgba(0, 0, 0, 0.4) 0px 12px 40px,
    inset 0 1px 0 rgba(255, 255, 255, 0.35);
}

.card-header-row {
  display: flex;

  align-items: center;

  gap: 12px;

  margin-bottom: 4px;
}

/* Icon circle - frosted pill */
.icon-circle {
  width: 48px;

  height: 48px;

  border-radius: 50%;

  background: rgba(255, 255, 255, 0.22);

  backdrop-filter: blur(6px);

  -webkit-backdrop-filter: blur(6px);

  border: 1px solid rgba(255, 255, 255, 0.3);

  display: flex;

  align-items: center;

  justify-content: center;

  flex-shrink: 0;
}

.card-icon {
  font-size: 26px !important;

  color: #fff !important;
}

.card-title-text {
  font-size: 13px;

  font-weight: 500;

  letter-spacing: 0.05em;

  text-transform: uppercase;

  color: rgba(255, 255, 255, 0.85);
}

.card-bottom-row {
  display: flex;

  align-items: flex-end;

  justify-content: space-between;

  padding-top: 10px;
}

.card-body-text {
  font-size: clamp(20px, 4vw, 28px);

  font-weight: 600;

  color: #fff;

  margin: 0;

  line-height: 1;

  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.card-sub-text {
  font-size: 11px;

  color: rgba(255, 255, 255, 0.7);

  margin: 5px 3px 0;
}

/* Percentage badge - frosted pill */
.pct-badge {
  font-size: 12px;

  font-weight: 500;

  padding: 5px 11px;

  border-radius: 20px;

  background: rgba(255, 255, 255, 0.22);

  backdrop-filter: blur(6px);

  -webkit-backdrop-filter: blur(6px);

  border: 1px solid rgba(255, 255, 255, 0.3);

  color: rgba(255, 255, 255, 0.95);

  white-space: nowrap;
}

.card-divider {
  border-color: rgba(255, 255, 255, 0.22) !important;

  margin: 0 4px;
}

/* =========================================================
   PUBLISHED DATE DIALOG
========================================================== */

.published-date-dialog {
  border-radius: 4px;
}

.published-date-dialog .v-card__text {
  padding: 20px 24px;
}

.published-date-dialog .v-text-field {
  margin-bottom: 8px;
}

/* =========================================================
   RESPONSIVE
========================================================== */

@media (max-width: 960px) {
  .table-wrapper {
    height: 260px;
  }

  .table-wrapper tbody {
    height: calc(260px - 56px);
  }

  .title {
    font-size: 18px !important;
  }
}

@media (max-width: 600px) {
  .table-wrapper {
    height: 220px;
  }

  .table-wrapper tbody {
    height: calc(220px - 48px);
  }

  .title {
    font-size: 16px !important;
  }

  .card-flex {
    padding: 6px;
  }

  .icon-circle {
    width: 38px;

    height: 38px;
  }

  .card-icon {
    font-size: 20px !important;
  }

  .card-title-text {
    font-size: 11px;
  }

  .pct-badge {
    font-size: 10px;

    padding: 4px 8px;
  }

  #RCitem {
    padding: 6px;

    font-size: 14px;
  }

  .customeDateSearch {
    margin-top: 4px;
  }
}

@media (max-width: 400px) {
  .card-body-text {
    font-size: 18px;
  }

  .card-sub-text {
    font-size: 10px;
  }
}
</style>